import React from 'react';
import { GlobalStyles, } from '@stepstone-genesis/components';
import { useUID } from '@stepstone-genesis/uid-library';
var ID_PREFIX = 'registration-success-confirmation-modal';
export var useHeaderZIndexWorkaround = function () {
    var _a;
    var uid = useUID();
    var dialogId = "".concat(ID_PREFIX, "-").concat(uid);
    var baseZIndex = 2000;
    var globalStyles = (_a = {},
        _a["[data-dialog-ref=\"".concat(dialogId, "\"]")] = {
            zIndex: "".concat(baseZIndex, " !important"),
        },
        _a["[data-dialog-ref=\"".concat(dialogId, "\"] > div")] = {
            zIndex: "".concat(baseZIndex + 20, " !important"),
        },
        _a);
    var GlobalDialogStyles = function () { return (React.createElement(GlobalStyles, { styles: globalStyles })); };
    return { dialogId: dialogId, GlobalDialogStyles: GlobalDialogStyles };
};
//# sourceMappingURL=dialogZIndex.js.map